import React, { useEffect, useState } from 'react';
import { store, useStoreValue } from 'react-context-hook';

import ls from './secureStorage';

const useSession = () => {
  const refreshSession = useStoreValue('last-session');
  const [currentSession, setCurrentSession] = useState(ls.get('session') || {});

  useEffect(() => {
    setCurrentSession(ls.get('session') || {});
  }, [refreshSession]);

  return currentSession;
};

export default useSession;
